import styled from '../../../theme/styled-with-theme';

export const StyledLabel = styled('label')`
  position: absolute;
  border-radius: ${({ theme }) => theme.borderRadius.input_desktop};
  font-weight: 500;
  font-size: 0.8em;
  padding: 0 4px 0 4px;
  margin-top: -8px;
  margin-left: 16px;
  background-color: #fff;
`;

export const TextAreaWrapper = styled('div')`
  width: 100%;
  height: 120px;
  border: 1px solid ${({ theme }) => theme.color.textInputPrimary};
  border-radius: ${({ theme }) => theme.borderRadius.input_desktop};
`;

export const TextArea = styled('textarea')`
  width: 100%;
  height: 100%;
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.input_desktop};
  resize: none;
  padding: 16px;
  &:focus {
    border: none;
    outline: none;
  }
`;
